export default {
  enums: [
    { id: 'OPERATOR' },
    { id: 'SELF_MADE' },
  ]
};